import React, { useEffect } from "react";
import { Switch } from "react-router-dom";
import { SecureRoute } from "@okta/okta-react";
import { useIdleTimer } from "@tailormed/common-client/services/idleTimer";
import { Layout } from "antd";
import { useSelector } from "react-redux";

import { EnvironmentHeader } from "../component/EnvironmentHeader";
import { MainView } from "../screen/MainView";
import { handleReturnFromSleep, renewTokenTimer } from "@tailormed/common-client/services/auth";
import { selectUser, selectIDPConfig } from "../store/selector";
import { oktaConfig } from "../constant/okta";
import { ChromeExtensionListener } from "../component/ChromeExtensionListener";
import { Routes } from "../constant/routes";
import { GRAY_50, WHITE } from "../constant/colors";
import { SideBar } from "../component/SideBar";
import { MainHeader } from "../component/MainHeader";
import { GeneralReport } from "../screen/GeneralReport";

const SecuredRouter = () => {
  const user = useSelector(selectUser);
  const idpConfig = useSelector(selectIDPConfig);

  useIdleTimer(user, idpConfig, oktaConfig.loginURI);

  useEffect(() => {
    const initAuthTimers = async () => {
      await renewTokenTimer(user, idpConfig, oktaConfig.loginURI);
      await handleReturnFromSleep(user, idpConfig, oktaConfig.loginURI);
    };
    initAuthTimers();
  }, []);

  return (
    <>
      <EnvironmentHeader />
      <Layout style={{ minHeight: "100vh", background: WHITE }}>
        <SideBar />
        <Layout style={{ background: GRAY_50, height: "100vh" }}>
          <MainHeader />
          <div style={{ flex: 1, overflowY: "auto" }}>
            <Switch>
              <SecureRoute path={Routes.ROOT + Routes.SELECT + Routes.GENERAL_REPORT} exact component={GeneralReport} />
              <SecureRoute path={Routes.ROOT + Routes.SELECT} component={MainView} />
              <SecureRoute path={Routes.ROOT} component={MainView} />
              <SecureRoute path={"/"} component={MainView} exact />
            </Switch>
          </div>
        </Layout>
        <ChromeExtensionListener />
      </Layout>
    </>
  );
};

export { SecuredRouter };
